export const pagePath = {
  form: '/checker',
  results: '/results',
  noResults: '/no-results',
};

export class ConcessionCalculatorGoogleAnalytics4 {
  constructor(pageTitle) {
    window.dataLayer = window.dataLayer || [];
    this.pageTitle = pageTitle;
  }

  _eventPageProps(path) {
    return {
      pageTitle: this.pageTitle,
      pageURL: window.location.href,
      pagePath: path,
      pageReferrer: document.referrer,
    };
  }

  event(eventName, eventProperties, path) {
    const payload = {
      event: eventName,
      ...eventProperties,
      ...this._eventPageProps(path),
    };

    window.dataLayer.push(payload);
  }

  pageView(path) {
    const payload = {
      event: 'spa_virtual_page_view',
      ...this._eventPageProps(path),
    };

    window.dataLayer.push(payload);
  }
}
